import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/ui/our-experience/jpg-png/reinvox-t-duo.png")